import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

export const isExciseLicenseNumber: ValidatorFn =
  Validators.pattern(`^HU[0-9]{11}$`);

export const exciseLicenseNumberValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const regExp = '^HU[0-9]{11}$';
  return String(control.value).match(new RegExp(regExp)) || !control.value
    ? null
    : { exciseLicenseNumber: true };
};
